import { Breadcrumbs, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const BreadCrumbs = () => {
  const [crumbArray, setCrumbArray] = useState(["All Campaign"]);
  const [headerTitle, setHeaderTitle] = useState("Campaigns");
  const location = useLocation();
  useEffect(() => {
    if (
      location.pathname === "/Email/accounts" ||
      location.pathname === "/Email/accounts/settings"
    ) {
      setHeaderTitle("Email Account");
    } else if (location.pathname === "/DashBoard/Campaign") {
      setHeaderTitle("All Campaigns");
    } else if (location.pathname === "/All-Campaign/Templates") {
      setHeaderTitle("All Campaigns");
    } else if (location.pathname === "/All-Campaign/New-Campaign") {
      setHeaderTitle("All Campaigns");
    } else if (location.pathname === "/All-Campaign/Schedule") {
      setHeaderTitle("All Schedules");
    } else if (
      location.pathname === "/Statistics" ||
      location.pathname === "/statistics"
    ) {
      setHeaderTitle("All Campaigns");
    } else if (location.pathname === "/EmailVerify") {
      setHeaderTitle("Email Verification");
    } else if (location.pathname === "/BulkMailVerification") {
      setHeaderTitle("Email Verification");
    } else if (
      location.pathname.includes("/Contacts/") &&
      location.pathname.length >= 10
    ) {
      // setCrumbArray(["Contacts","All Contacts"])
      setHeaderTitle("All Lists");
    } else if (location.pathname === "/Lists") {
      // setCrumbArray(["Contacts","Lists"])
      setHeaderTitle("All Lists");
    } else if (location.pathname === "/Replies") {
      // setCrumbArray(["Email Warm-up","All Warmups"])
      setHeaderTitle("All Replies");
    } else if (location.pathname === "/Warmup-Analytics") {
      // setCrumbArray(["Email Warm-up","All warm-ups"])
      setHeaderTitle("Warm-up campaign progress");
    } else if (location.pathname === "/MailWarmUp") {
      // setCrumbArray(["Email Warm-up","New Warmup"])
      setHeaderTitle("Warm-up");
    } else if (location.pathname === "/All-Campaign/New-Campaign") {
      // setCrumbArray(["All campaign","New campaign"])
      setHeaderTitle("New campaign");
    } else if (
      location.pathname === "/Goals" ||
      location.pathname.includes("/Goals/") ||
      location.pathname.includes("/Goal/leads")
    ) {
      // setCrumbArray(["Pricing"])
      setHeaderTitle("Goals");
    } else if (
      location.pathname === "/Accounts" ||
      location.pathname.includes("/Accounts/") ||
      location.pathname.includes("/api/documentation/")
    ) {
      // setCrumbArray([])
      setHeaderTitle("My Account");
    } else if (
      location.pathname === "/Pricing" ||
      location.pathname === "/pricing"
    ) {
      // setCrumbArray(["Pricing"])
      setHeaderTitle("Pricing");
    } else if (
      location.pathname === "/Unibox" ||
      location.pathname === "/unibox"
    ) {
      setHeaderTitle("Unibox");
    } else if (
      location.pathname === "/integrations" ||
      location.pathname === "/Integrations"
    ) {
      // setCrumbArray(["Pricing"])
      setHeaderTitle("Integrations");
    }
  }, [location.pathname]);
  return (
    <p
      style={{
        fontFamily: "Source Sans 3",
        color: "#393939",
        fontSize: "24px",
        fontWeight: 700,
        fontStyle: "normal",
      }}
    >
      {headerTitle}
    </p>
  );
};

export default BreadCrumbs;
